import {
    type DeleteSentNotificationResponseType,
    type DeleteSentNotificationRequestType
} from "./type";
import {
    request
} from "../request";

const deleteSentNotification = async (
    params: DeleteSentNotificationRequestType
): Promise<DeleteSentNotificationResponseType> => {
    return await request<DeleteSentNotificationResponseType>(
        "/notification/deleteSentNotification",
        {
            body: JSON.stringify(params),
            method: "POST"
        }
    );
};
export default deleteSentNotification;
